import axios from 'axios';
import { ERP } from './endpoint';
import auth from '../../common/utility/auth';

const ignoreInterceptions = [
    `${ERP}seguridad/authentication`,
    `${ERP}integracion/portal`,
    `${ERP}integracion/portal/pdf`,
    `${ERP}integracion/portal/xml`,
    `${ERP}seguridad/authentication/recover-password`
];

class interceptor {
    init() {
        axios.interceptors.request.use(async config => {
            if (ignoreInterceptions.filter(m => m === config.url).length > 0)
                return config;

            if (ignoreInterceptions.filter(m => config.url.match(m)).length > 0)
                return config;

            /* START - TIMEOUT LOCAL STORAGE */
            var timeOutLocalStorage = auth.user().expiry;
            const now = new Date();
            if (timeOutLocalStorage === undefined || timeOutLocalStorage === null || now.getTime() > timeOutLocalStorage) {
                localStorage.removeItem('user')
                window.location.reload();
            }
            /* END - TIMEOUT LOCAL STORAGE */

            config.headers = {
                'x-api-token': auth.user().token,
                'x-api-customer': auth.user().integrationCode,
                'x-api-username': auth.user().userName
            };
            
            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        axios.interceptors.response.use(async response => {
            return response;
        }, function (error) {
            return Promise.reject(error);
        });
    }
}
export default new interceptor();